module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/members/members-show/members-show.component.scss
// module id = ./src/app/views/setting/members/members-show/members-show.component.scss
// module chunks = main